import styled from '@emotion/styled'
import { Card } from 'react-bootstrap'

export const FBTDiv = styled.div`
  label: FBTDiv;
  border: 1px solid ${(props) => props.theme.colors.borderColor};
  box-sizing: border-box;
  padding: 10px;
  border-radius: 5px;
  background: ${(props) => props.theme.backgrounds.backGround3};
  box-shadow: 0px 1px 5px ${(props) => props.theme.colors.shadowColour};
  -webkit-boxshadow: 0px 1px 5px ${(props) => props.theme.colors.shadowColour};
  margin-bottom: 18px;
`

export const GreenH5 = styled.h5`
  label: GreenH5;
  font-weight: bold;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.primary 
      : '#002F68'} !important;
  line-height: 25px;
  min-height: 50px;
  display: flex;
  align-items: flex-end;
`

export const GreenCard = styled(Card)`
  label: GreenCard;
  background-color: ${(props) =>
    props.white
      ? '#fff'
      : props.pale
      ? props.theme.brand === 'Maxxia'
        ? props.theme.colors.primaryLightText
        : '#DAFAF8'
      : props.theme.brand === 'Maxxia'
      ? '#003D79'
      : '#3CB387'};
  color: ${(props) => (props.dark ? '#fff' : props.theme.brand === 'Maxxia' ? props.theme.colors.primary : '#002F68')};
  font-size: ${(props) =>
    props.smaller ? '18px' : props.theme.brand === 'Maxxia' ? '26px' : '20px'};
  height: 124px;
  border-radius: 10px;
  margin-bottom: 0.7rem;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? '700' : '900')};
  border: ${(props) =>
    props.dark
      ? 'none '
      : props.white
      ? props.theme.brand === 'Maxxia'
        ? 'solid 1px #d14200'
        : 'solid 2px #002F68'
      : props.theme.brand === 'Maxxia'
      ? 'solid 1px #cccccc'
      : 'none'};
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export const PlusSignDiv = styled.div`
  label: PlusSignDiv;
  font-size: 30px;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? '700' : '900')};
`

export const CardDetails = styled.div`
  label: GreyTextDiv;
  color: ${(props) => props.theme.colors.grey2};
  font-size: 16px;
  > strong {
    color: ${(props) =>
      props.theme.brand === 'Maxxia'
        ? props.theme.colors.grey2
        : props.theme.colors.textDarkblack};
  }
`

export const IconText = styled.span`
  label: IconText;
  padding-left: 14px;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const AnnualKmText = styled.div`
  label: AnnualKmText;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.positive};
  margin-bottom: 12px;
  margin-top: ${(props) => (props.theme.brand === 'Maxxia' ? '12px' : '0px')};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? '700' : '900')};
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '24px' : '19px')};
`

export const CardTitleSpan = styled.span`
  label: CardTitleSpan;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? '400' : '700')};
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '14px' : '16px')};
`

export const CardAmountSpan = styled.span`
  label: CardAmountSpan;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? '400' : '700')};
`

export const CardGSTAmountSpan = styled.span`
  label: CardGSTAmountSpan;
  font-size: 12px;
  color: ${(props) => props.theme.colors.grey2};
`
